<template>
    <component
        :is="tag"
        v-if="content"
        :class="[light ? 'dm-h-light' : '', headingClass, 'dm-h']"
        >{{ content }}</component
    >
</template>

<script setup lang="ts">
const props = defineProps({
    tag: {
        type: [String, null],
        default: 'div',
    },
    light: {
        type: Boolean,
        default: false,
    },
    headingClass: {
        type: [String, null],
        default: 'div',
    },
    content: {
        type: [String, null],
    },
})

const headingClass = computed(() => {
    return props.tag ? 'dm-' + props.tag : ''
})
</script>
